<div class="modal fade {{styleClass}}" bsModal #staticModal="bs-modal" [config]="{backdrop: 'static', show: shown}"
  tabindex="-1" role="dialog" aria-labelledby="dialog-static-name" (onHidden)="onModalHidden()">
  <div class="modal-dialog modal-{{size}}">
    <div class="modal-content">
      <div class="modal-header">
        <!-- Header template specified -->
        <ng-content select="app-modal-header"></ng-content>
        <!-- No header template specified -->
        @if (!headerContent) {
          <h4 class="modal-title pull-left">{{heading}}</h4>
          @if (showCloseBtn) {
            <button type="button" class="close pull-right" aria-label="Close" (click)="hide()">
              <i class="fa fa-times"></i>
            </button>
          }
        }
      </div>
      <div class="modal-body">
        <ng-content select="app-modal-body"></ng-content>
      </div>
      @if (footerContent) {
        <div class="modal-footer">
          <ng-content select="app-modal-footer"></ng-content>
        </div>
      }
    </div>
  </div>
</div>
